import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurplePhone } from 'Images';

interface IContactDetails {
  contacts: {
    cellPhoneNumber: string | null;
    homePhoneNumber: string | null;
    email: string;
  };
}

export const ContactDetails = ({ contacts }: IContactDetails) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .therapy;

  return (
    <Stack
      gap='8px'
      component='ul'
      sx={{
        p: 0,
        m: 0,
      }}
    >
      <Typography
        variant='body5'
        component='h4'
        sx={{
          width: 'fit-content',
          cursor: 'text',
        }}
      >
        {dictionary.contactDetails}
      </Typography>
      {contacts.cellPhoneNumber && (
        <Stack direction='row' alignItems='center' gap='8px' component='li'>
          <Avatar
            alt={dictionary.cellphone}
            src={PurplePhone}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography
            variant='body3'
            sx={{
              cursor: 'text',
            }}
          >
            {contacts.cellPhoneNumber}
          </Typography>
        </Stack>
      )}
      {!contacts.cellPhoneNumber && contacts.homePhoneNumber && (
        <Stack direction='row' alignItems='center' gap='8px' component='li'>
          <Avatar
            alt={dictionary.telephone}
            src={PurplePhone}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography
            variant='body3'
            sx={{
              cursor: 'text',
            }}
          >
            {contacts.homePhoneNumber}
          </Typography>
        </Stack>
      )}
      {!contacts.cellPhoneNumber && !contacts.homePhoneNumber && (
        <Typography
          variant='body3'
          sx={{
            cursor: 'text',
          }}
        >
          {dictionary.noData}
        </Typography>
      )}
    </Stack>
  );
};
